module.exports = __webpack_public_path__ + "static/media/gallery-21.de2d89a7.jpg";